module.exports = __webpack_public_path__ + "static/media/about_icon.c983716e.jpg";